<template>
  <el-dialog
    title="Ayuda con mi compra"
    :visible.sync="verDetalles"
    :fullscreen="true"
    :modal="false"
    :show-close="false"
    :before-close="cerrarModal"
  >
    <div
      class="data-vtex"
      v-loading="!dataVtex"
      element-loading-text="Recuperando información del pedido..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 0.8)"
    >
    
      <el-row :gutter="20" v-if="dataVtex && cleanItems">
        <el-col :sm="24" :offset="0">
          <h3 class="titulo-motivo-h3">{{ datos.motivo }}</h3>
          <h4 class="items-seleccion">
            <!-- <el-button
              type="default"
              icon="el-icon-back"
              style="
                font-weight: bold;
                padding: 4px 8px;
                line-height: 0.3;
                margin: -9px 10px;
                display: block;
                float: left;
              "
              @click="cerrarModal"
            ></el-button> -->
            Seleccione los productos con inconvenientes

            <!-- <el-button
              type="default"
              class="hidden-xs-only"
              style="float: right; margin-top: -5px"
              size="mini"
              v-if="products_selected.length"
              :loading="procesando == 'derivando' || procesando == 'cancelar'"
              @click="generarReclamo"
              >Generar reclamo</el-button
            > -->
          </h4>
          <ul class="data-vtex-ul">
            <li
              v-for="i in orderBy(dataVtex.items, 'orden', -1)"
              :key="i.uniqueId"
              :class="getClassItem(i)"
              @click="selectProductOption(i)"
            >
              <!-- <img :src="i.imageUrl" alt /> -->
              <el-image :src="i.imageUrl" :fit="'contain'" class="thumbnail">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline" style="font-size:15px"></i>
                </div>
              </el-image>
              <p>
                {{ getRealQuantity(i) }}
                {{ getRealQuantity(i) | pluralize(["unidad", "unidades"]) }} -
                {{ i.name.toLowerCase() }}
                <span
                  v-if="i.articulo_reclamo"
                  style="font-size: 13.5px; color: #f44336; font-weigth: 500"
                >
                  <br />
                  Seleccionado:
                  <strong>
                    {{ i.reclamo_cantidad }} {{ i.articulo_reclamo.nombre }}
                  </strong>
                </span>
                <span v-if="i.modificado">
                  <br />
                  <strong
                    style="font-size: 12px; color: #f44336; font-weigth: 500"
                    v-if="i.quantity - i.cambios.quantity == 0"
                    >PRODUCTO ELIMINADO ({{ i.cambios.quantity }}
                    {{
                      i.cambios.quantity | pluralize(["UNIDAD", "UNIDADES"])
                    }}) POR FALTA DE STOCK</strong
                  >
                  <strong
                    style="font-size: 12px; color: #f44336; font-weigth: 500"
                    v-if="i.quantity - i.cambios.quantity > 0"
                    >ENTREGA PARCIAL SE QUITARON {{ i.cambios.quantity }}
                    {{ i.cambios.quantity | pluralize(["UNIDAD", "UNIDADES"]) }}
                    DEL PRODUCTO POR FALTA DE STOCK</strong
                  >
                </span>
              </p>
              <transition name="fade">
                <strong
                  class="el-icon-delete item-selected-icon"
                  v-if="i.selected === i.uniqueId"
                  :class="{ 'flip-in-hor-bottom': i.uniqueId == i.selected }"
                ></strong>
                <strong
                  class="el-icon-circle-plus-outline item-unselected-icon"
                  :class="{ 'flip-in-hor-bottom': i.selected !== i.uniqueId }"
                  v-else
                ></strong>
              </transition>
            </li>
          </ul>
         
        </el-col>
       
      </el-row>

      <!-- {{vtex}} -->
    </div>
     <div class="botoneraGenerar" >
              <el-button type="primary" size="default" style="width:120px" @click="cerrarModal"
                >Regresar</el-button
              >
              <el-button
              :disabled="products_selected.length ? false : true"
                type="verde"
            
                size="default" 
                :loading="procesando == 'derivando' || procesando == 'cancelar'"
                @click="generarReclamo"
                >
                <span v-if="products_selected.length"> Generar reclamo</span>
                <span v-else>Seleccionar producto/s</span>
               
                
                </el-button
              >
            </div>
    <el-dialog
      width="360px"
      center
      :top="'1vh'"
      custom-class="modal-inner"
      title="Informacón adicional"
      :visible.sync="innerVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      append-to-body
    >
      <div class="establecer">
        <strong>
          <small>Establecer opciones para:</small> <br />
          <span style="color: red">{{ item_selected.name }}</span>
        </strong>
        <el-row :gutter="10">
          <el-col
            :sm="24"
            :offset="0"
            style="border-top: 1px solid #f1f1f1; margin-top: 15px"
          >
            <label
              for=""
              style="padding-top: 10px; display: block; line-height: 1"
              >Motivo del reclamo

              <small
                style="color: red"
                v-if="item_selected.articulo_reclamo_error == 1"
              >
                <br />
                seleccione un motivo</small
              >
            </label>
            <div>
              <h3 v-if="item_selected.articulo_reclamo">
                {{ item_selected.articulo_reclamo.nombre }}
                <br>
                      <small
                    style="color: red; line-height: 1"
                    v-if="datos.motivo_id == 6"
                  >
                    Es necesario subir una foto del producto y del código de barras del mismo
                    
                    </small
                  >
              </h3>

              <el-row :gutter="10">
                <el-col :sm="24" :offset="0">
                  <el-upload
                    class="upload-demo"
                    style="margin-top: -2px"
                    ref="upload"
                    :limit="5"
                    :on-success="subidaOk"
                    :on-error="subidaError"
                    :data="{ articulo: this.item_selected.productId }"
                    :show-file-list="true"
                    :action="cargarFotosUrl"
                    :auto-upload="false"
                    v-if="(datos.motivo_id == 9 || datos.motivo_id == 6)"
                  >
                    <el-button
                      slot="trigger"
                      type="primary"
                      class="btn-foto"
                      size="medium"
                      >Cargar Foto (obligatorio)</el-button
                    >
                  </el-upload>
             
                  <small
                    style="color: red"
                    v-if="sinimg && datos.motivo_id == 9"
                  >
                    {{ sinimg }}</small
                  >
                </el-col>

                <el-col
                  :sm="24"
                  :offset="0"
                  v-for="(f, index) in fotos"
                  :key="index"
                >
                  <el-card
                    id="fotos"
                    :body-style="{ padding: '5px' }"
                    style="margin-top: 10px; position: relative; height: 200px"
                    v-if="f.path.split('.')[1] != 'pdf'"
                  >
                    <el-button
                      type="danger"
                      size="mini"
                      class="btn-borrar"
                      icon="el-icon-delete"
                      @click="borrarImagen(f.id, index)"
                      circle
                    ></el-button>
                    <el-image
                      style="width: 100%; display: block"
                      :src="server + f.path"
                      :preview-src-list="fotos.map((f) => server + f.path)"
                    >
                    </el-image>

                    <!-- <img  :src="f" alt="" style="width:100%"> -->
                  </el-card>
                  <el-card
                    :body-style="{ padding: '5px' }"
                    style="
                      margin-top: 10px;
                      position: relative;
                      height: 200px;
                      cursor: pointer;
                    "
                    v-if="f.path.split('.')[1] == 'pdf'"
                  >
                    <el-button
                      type="danger"
                      size="mini"
                      class="btn-borrar"
                      icon="el-icon-delete"
                      @click="borrarImagen(f.id, index)"
                      circle
                    ></el-button>
                    <pdf
                      style="height: 600px"
                      :src="server + f.path"
                      @click.native="openPdf(server + f.path)"
                    ></pdf>
                  </el-card>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col
            :sm="24"
            :offset="0"
            style="border-top: 1px solid #f1f1f1; margin-top: 15px"
            v-if="datos.motivo_id != 6"
          >
            <label style="padding-top: 10px; display: block" for=""
              >Cantidad de unidades con problemas
            </label>
            <el-input-number
              :min="1"
              :max="item_selected.quantity"
              v-model="item_selected.reclamo_cantidad"
            ></el-input-number>
            <small
              style="color: red"
              v-if="item_selected.articulo_reclamo_error == 2"
            >
              <br />
              ingrese la cantidad de artículos</small
            >
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col
            :sm="24"
            style="border-top: 1px solid #f1f1f1; margin-top: 15px"
          >
            <el-button
              type="primary"
              size="default"
              style="display: block; width: 100%; margin: 8px auto"
              @click="selectProduct(item_selected)"
              >ACEPTAR</el-button
            >
            <el-button
              type="info"
              size="default"
              style="display: block; width: 100%; margin: 8px auto"
              @click="reset(item_selected)"
              >CANCELAR</el-button
            >
          </el-col>
        </el-row>
      </div>
      <div id="selector-pedidos">
         <el-dialog
        width="360px"
        center
        :top="'1vh'"
        custom-class="modal-inner"
        title="Informacón adicional"
        :visible.sync="tipoReclamo"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        append-to-body
      >
        <div class="seleccionaOpcion">
          <p>
            Te pedimos disculpa por los inconvenientes ocasionados, por favor
            elegí una opcíon para continuar
          </p>
          <el-button
            type="default"
            plain
            class="btntipoSolicitud"
            :loading="procesando == 'renviar'"
            :disabled="procesando ? true : false"
            style="margin-top: -1px"
            @click="reenviarProductos('renviar')"
          >
            Quiero que me envien los productos faltantes <br>
            <small style="color:red;">Sujeto a disponibilidad de STOCK</small>
          </el-button>
          <el-button
            type="default"
            plain
            class="btntipoSolicitud"
            :loading="procesando == 'cancelar'"
            :disabled="procesando ? true : false"
            @click="reenviarProductos('cancelar')"
          >
            Quiero solicitar la devolución del dinero
          </el-button>
          <el-button
            :disabled="procesando ? true : false"
            type="default"
            plain
            class="btntipoSolicitud"
            @click="tipoReclamo = false"
            >Regresar</el-button
          >
        
        </div>
      </el-dialog>

      </div>
    </el-dialog>
   
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import { EventBus } from "@/event-bus.js";
import { HTTP, cargarFotosUrl, FILES_PATH } from "@/axios.js";
import Vue2Filters from "vue2-filters";

export default {
  props: ["detallePedido", "datos", "motivo"],
  mixins: [Vue2Filters.mixin],
  components: {},
  data() {
    return {
      cargarFotosUrl: cargarFotosUrl,
      FILES_PATH: FILES_PATH,
      sinimg: false,
      fotos: [],
      procesando: false,
      cleanItems: true,
      tipoReclamo: false,
      settings: {
        suppressScrollY: false,
        suppressScrollX: true,
        wheelPropagation: false,
      },
      tieneDevolucion: false,
      generando: false,
      verDetalles: false,
      total_pago: 0,
      reclamo_cantidad: 0,
      vtex: undefined,
      innerVisible: false,
      articulo_reclamo: undefined,
      tipo_operacion: undefined,
      item_selected: {},
      products_selected: [],
      products_update: [],
      pedido: this.$route.params.pedido ? this.$route.params.pedido : 0,
      options: [
        { id: 1, nombre: "Producto no recibido / faltante" },
        { id: 2, nombre: "Producto dañado o deteriorado" },
        { id: 4, nombre: "El producto no es lo que esperaba" },
        { id: 5, nombre: "Producto equivocado" },
        // { id: 3, value: "deteriorado" },
      ],
    };
  },
  created() {
    EventBus.$on("verListadoProductos", (d) => {
      this.verDetalles = d;
    });
    if (this.motivo == 2 && this.datos.fecha_dev) {
      this.tieneDevolucion = true;
    }
    console.log("dataVtext listadoProductos", this.dataVtex);
    this.getDataVtex();
  },

  computed: {
    ...mapGetters(["isLoading", "dataVtex"]),
  },

  methods: {
    ...mapActions({
      vuexSelectedProduct: "selectedProduct",
      vuexprocesarReclamo: "procesarReclamo",
    }),
    getArticuloReclamo(m) {
      let reclamo;
      switch (m) {
        case 2:
          reclamo = { id: 1, nombre: "Producto no recibido / faltante" };
          break;
        case 6:
          reclamo = { id: 5, nombre: "Producto equivocado" };
          break;
        case 9:
          reclamo = { id: 2, nombre: "Producto dañado, deteriorado o vencido" };
          break;
      }

      return reclamo;
    },
    reenviarProductos(tipo, retornar = false) {
      let wc = {};
      let motivo = this.datos.motivo_id;
      console.log(tipo, this.datos.envio);
      this.tipo_operacion = tipo;

      this.products_selected.forEach((e, i) => {
        this.products_selected[i].tipo_operacion = tipo;
      });

      if (motivo == 2) {
        switch (tipo) {
          case "renviar":
            wc.wc_tipo = this.datos.envio ? 25329 : 18270;
            wc.priority = "";
            break;
          case "cancelar":
            wc.wc_tipo = 25329;
            wc.priority = "hight";
            break;
        }
      }

      if (motivo == 6) {
        switch (tipo) {
          case "renviar":
            wc.wc_tipo = this.datos.envio ? 21147 : 18270;
            wc.priority = "";
            break;
          case "cancelar":
            wc.wc_tipo = 25329;
            wc.priority = "hight";
            break;
        }
      }
      if (motivo == 9) {
        switch (tipo) {
          case "renviar":
            wc.wc_tipo = this.datos.envio ? 21147 : 18270;
            wc.priority = "";
            break;
          case "cancelar":
            wc.wc_tipo = 25329;
            wc.priority = "hight";
            break;
        }
      }
      if (retornar) {
        return wc;
      } else {
        setTimeout(() => {
          this.derivarReclamo(wc);
        }, 50);
      }
    },
    reset(item) {
      console.log("item cancelado", item);
      this.cleanItems = false;
      item.selected = true;
      setTimeout(() => {
        this.cleanItems = true;

        this.selectProductOption(item);
      }, 100);
    },

    generarReclamo() {
       
   
        let totalDevolucion =
        this.products_selected.reduce(
          (a, b) => a + parseInt(b.sellingPrice * this.getRealQuantity(b)),
          0
        ) / 100;
      console.log("totalDevolucion", totalDevolucion);
      if (totalDevolucion > 500) {
        this.tipoReclamo = true;
      } else {
        this.procesando = "derivando";
        this.tipo_operacion = "cancelar";
        let wc = {};
        wc.wc_tipo = this.reenviarProductos("cancelar");
        wc.priority = "hight";
        setTimeout(() => {
          this.products_selected.forEach((e, i) => {
            this.products_selected[i].tipo_operacion = this.tipo_operacion;
          });
          // this.derivarReclamo(wc);
        }, 10);
      }
   
      
    },
    derivarReclamo(wc = {}, priority = false) {
      // this.products_selected.filter((tag, index, array) => array.findIndex(t => t.uniqueId == tag.uniqueId) == index);
   
     setTimeout(() => {
        this.procesando = this.tipo_operacion;
      let items = "";
      let Fotos = "";
      let motivoIngresado = this.datos.motivos.filter(
        (e) => e.id == this.datos.motivo_id
      )[0] ;

      let datosWc = {
        dni: this.datos.dni,
        email: this.datos.mail_d ? this.datos.mail_d : "",
        fechaVtex: this.$date(this.datos.vtex_fecha.date).format(
          "DD/MM/YYYY HH:mm"
        ),
        nombre: this.datos.nombre + " " + this.datos.apellido,
       telefono: this.datos.telefono,
        envio: this.datos.envio,
        totalOperacion: this.datos.importe / 100,
        wcTipo: wc.wc_tipo ? wc.wc_tipo : motivoIngresado.wc_tipo,
        vtex_id: this.datos["vtex_id"],
        motivo_id: motivoIngresado.id,
        status: "open",
        priority: wc.priority ? wc.priority : "",
      };

      if ([2, 6, 5, 9].includes(motivoIngresado.id)) {
        this.products_selected.filter((tag, index, array) => array.findIndex(t => t.uniqueId == tag.uniqueId) == index);
        this.products_selected.forEach((e) => {
          if (e.arrayfotos && e.arrayfotos.length) {
            Fotos = `<strong style="font-size: 12px; display:block" >Fotos</strong>`;
            e.arrayfotos.forEach((f, i) => {
              Fotos += `<a href="${f}" target="_blank" style="margin-right:5px" >foto-${
                i + 1
              }</a>`;
            });
          }

          items += `<tr style="border: 1px solid #F1F1F1;">
                        <td colspan="2" style="display: inline-flex; flex-direction: row; align-items: center; padding: 5px;">
                        <strong style="font-size:12px; display:block" >Cant. - Nombre</strong>
                      ${e.reclamo_cantidad}un. -  ${e.name}
                        </td>
                        </tr>
                        <tr style="border: 1px solid #F1F1F1;">
                        <td style="border: 1px solid #F1F1F1;  padding: 5px;">
                       <strong style="font-size:12px; display:block" >Código</strong>
                          ${
                          e.productId
                        }
                        </td>
                        <td style="border: 1px solid #F1F1F1;  padding: 5px;">
                          <strong style="font-size:12px; display:block" >Precio</strong>
                          ${
                          e.sellingPrice / 100
                        }</td>
                        </tr>
                         <tr style="border: 1px solid #F1F1F1;">
                        <td colspan="2" style="border: 1px solid #F1F1F1;  padding: 5px;"><small>
                           <strong style="font-size:12px; display:block" >Motivo</strong>
                          ${
                          e.articulo_reclamo.nombre
                        }${
            e.tipo_operacion == "renviar"
              ? " (quiero que me reenvien el producto)"
              : "(quiero que me devuelvan el dinero)"
          }</small>
                      
                        </td>
                     
                        <td colspan="2" style="border: 1px solid #F1F1F1;  padding: 5px; text-align:center">
                           
                          ${Fotos}</td>
                      </tr>`;
        });
        datosWc.content = `<table style="width: 100%; border-collapse: collapse; font-size:14px">
                                  
                                	<thead>                                   							
                              	    <tr style="border: 1px solid #F1F1F1;">	        			
                              	      <td style="border: 1px solid #F1F1F1; padding: 5px;">Producto</td>
                              	      <td style="border: 1px solid #F1F1F1; padding: 5px;">Código</td>
                              	      <td style="border: 1px solid #F1F1F1; padding: 5px;">Precio</td>
                              	      <td style="border: 1px solid #F1F1F1; padding: 5px;">Estado</td>				
                              	      <td style="border: 1px solid #F1F1F1; padding: 5px;">Cantidad</td>
                              	      <td style="border: 1px solid #F1F1F1; padding: 5px;">Fotos</td>
                              	    </tr>
                              	  </thead>
                              	        	<tbody>
                                            ${items}
                              	        	</tbody>
                              </table>`;
      }
      setTimeout(() => {
        let result = this.vuexprocesarReclamo({
          datosWc,
          motivoIngresado,
          productos: this.products_selected,
        });
        result.then((res) => {
          console.log("Listado de pedidos", res);
          this.procesando = false;
          this.tipoReclamo = false;
          if (res.ok && res.reclamo && res.reclamo.reclamo) {
            EventBus.$emit("procesarArrepentimiento", res);
          }
          else{
            this.$alert("no se pudo procesar el reclamo", "Error", {
              type: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .catch( () => {
           this.procesando = false;
          this.tipoReclamo = false;
           this.$alert("no se pudo procesar el reclamo", "Error", {
              type: "error",
              confirmButtonText: "Aceptar",
            });
        })
      }, 100);
     }, 100);
     
    },
    selectProductOption(item) {
      // this.products_selected.push(item);
      let cantidaReal = this.getRealQuantity(item);
      if (!item.selected && cantidaReal) {
        this.item_selected = item;

        setTimeout(() => {
          this.item_selected.articulo_reclamo = this.getArticuloReclamo(
            this.datos.motivo_id
          );
          if (this.datos.motivo_id == 6) {
            this.item_selected.reclamo_cantidad = cantidaReal;
          }
          this.innerVisible = true;
        }, 50);
      } else {
        this.item_selected = {};
        this.innerVisible = false;
        let aux = this.vtex.items;
        let selected = this.vtex.items.findIndex(
          (obj) => obj.uniqueId === item.uniqueId
        );
        if (this.products_selected.length) {
          this.products_selected = this.products_selected.filter((f) => {
            return f.uniqueId !== item.uniqueId;
          });
        }

        aux[selected].articulo_reclamo = 0;
        aux[selected].reclamo_cantidad = 0;
        aux[selected].reclamo_motivo = "";
        aux[selected].selected = undefined;

        setTimeout(() => {
          this.vtex.items = [];
          this.vtex.items = aux;
        }, 100);
      }

  
      this.vuexSelectedProduct({ products: this.products_selected });

      //       setTimeout(() => {
      //       this.vtex.items = [];
      //       this.vtex.items = aux;
      //   }, 250);
    },
    clearProductOption(item) {
      this.item_selected = {};
      // this.innerVisible = false;
      let aux = this.vtex.items;
      let selected = this.vtex.items.findIndex(
        (obj) => obj.uniqueId === item.uniqueId
      );
      if (this.products_selected.length) {
        this.products_selected = this.products_selected.filter((f) => {
          return f.uniqueId !== item.uniqueId;
        });
      }

      aux[selected].articulo_reclamo = 0;
      aux[selected].reclamo_cantidad = 0;
      aux[selected].articulo_reclamo_error = 0;
      aux[selected].reclamo_motivo = "";
      aux[selected].selected = undefined;

      setTimeout(() => {
        this.vtex.items = [];
        this.vtex.items = aux;
      }, 100);

      //       setTimeout(() => {
      //       this.vtex.items = [];
      //       this.vtex.items = aux;
      //   }, 250);
    },
    selectProduct(item) {
      let aux = this.vtex.items;
      console.log('selectProduct',this.datos.motivo_id);
      let selected = this.vtex.items.findIndex(
        (obj) => obj.uniqueId === item.uniqueId
      );

      if (
        [9,6].includes(this.datos.motivo_id) &&
        this.$refs.upload &&
        !this.$refs.upload.uploadFiles.length
      ) {
        // this.$alert("Necesitamos al menos una imágen del producto con incovenientes")
        this.sinimg =
          "Necesitamos al menos una imágen del producto con incovenientes";
      } else {
        if (!item.selected) {
          console.log("!item.selected");
          if (this.$refs.upload) {
            this.$refs.upload.submit();
          }

          if (
            this.item_selected.articulo_reclamo &&
            this.item_selected.reclamo_cantidad
          ) {
            this.products_selected.push(item);
            aux[selected].selected = item.uniqueId;
            this.innerVisible = false;
          } else {
            if (!this.item_selected.articulo_reclamo) {
              this.item_selected.articulo_reclamo_error = 1;
            }
            if (!this.item_selected.reclamo_cantidad) {
              this.item_selected.articulo_reclamo_error = 2;
            }

            //   return false;
          }
        } else {
          if (this.products_selected.length) {
            this.products_selected = this.products_selected.filter((f) => {
              return f.uniqueId !== item.uniqueId;
            });
          }
          aux[selected].selected = undefined;
        }
        this.vtex.items = [];
        this.vtex.items = aux;
        this.vuexSelectedProduct({ products: this.products_selected });
      }

      setTimeout(() => {
          this.vtex.items = aux
      }, 10);
    },
    cerrarModal() {
      // EventBus.$emit("cerrarModal", 1);

      this.item_selected = {};

      this.dataVtex.items.forEach((e, i) => {
        this.clearProductOption(e);
      });

      setTimeout(() => {
        this.products_selected = [];
        this.verDetalles = false;
      }, 100);
    },
    getRealQuantity(i) {
      let quantity = 0;

      if (i.cambios && i.cambios.quantity) {
        quantity = i.quantity - i.cambios.quantity;
      } else {
        quantity = i.quantity;
      }

      return quantity;
    },

    getDataVtex() {
      this.vtex = this.dataVtex;

      if (this.vtex) {
        if (this.vtex.changesAttachment) {
          let remove = this.vtex.changesAttachment.changesData
            .map((cd) => cd.itemsRemoved)
            .reduce((prev, next) => prev.concat(next));

          for (let i = 0; i < this.vtex.items.length; i++) {
            for (let index = 0; index < remove.length; index++) {
              if (
                parseInt(remove[index].id) === parseInt(this.vtex.items[i].id)
              ) {
                this.products_update.push(this.vtex.items[i]);
                this.vtex.items[i].modificado = 1;
                this.vtex.items[i].cambios = remove[index];

                if (this.vtex.items[i].quantity - remove[index].quantity)
                  this.vtex.items[i].orden = -99;
                else this.vtex.items[i].orden = -100;
              }
            }
            if (!this.vtex.items[i].modificado) {
              this.vtex.items[i].modificado = 0;
              this.vtex.items[i].cambios = {};
              this.vtex.items[i].orden = 1;
            }
          }
          console.log(" this.vtex.items", this.vtex.items);
        }
      } else {
        setTimeout(() => {
          this.getDataVtex();
        }, 6000);
      }
    },
    getTotalPago(pagos) {
      //   parseFloat(pagos[0]) //+ parseFloat(pagos[1]/100) + parseFloat(pagos[2]/100)  + parseFloat(pagos[4]/100)
      let total = pagos.map((p) => p.value).reduce((a, b) => a + b);

      return total / 100;
    },
    getClassItem(i) {
      let clase = "item-ok";
      if (i.modificado) {
        if (i.quantity - i.cambios.quantity == 0) {
          clase = "item-cambio";
        } else {
          clase = "item-cambio-parcial";
        }
      }

      if (i.uniqueId === i.selected) {
        clase = clase + " selected";
      } else {
        clase = "item-ok";
      }
      return clase;
    },
    subidaOk(response) {

        //  this.products_selected.push(this.item_selected)
        console.log('subidaOk',response);
      if (response && response.status) {
        let articulo = response.articulo;
                 this.products_selected.forEach((e, i) => {
                   
          if (!this.products_selected[i].arrayfotos) {
            this.products_selected[i].arrayfotos = [];
            this.products_selected[i].idsImg = [];
          }
          if (articulo == e.productId) {
            this.products_selected[i].arrayfotos.push(
              this.FILES_PATH + response.url
            );
             this.products_selected[i].idsImg.push(
              response.id
            );
          }
        });
      
        setTimeout(() => {
           console.log('subidaOk',response);
        console.log('subidaOkproducts_selected', this.products_selected);
       
        }, 150);
     
      } else {
        this.$alert(
          "no se pudo subir el archivo, actualice el navegador y reintente"
        );
      }
    },
    subidaError(err) {
      this.$alert(
        "no se pudo subir el archivo, actualice el navegador y reintente " + err
      );
    },
    handleChange(file) {
      const isPNG = file.raw.type === "image/png";
      const isJPG = file.raw.type === "image/jpg";
      const isJPEG = file.raw.type === "image/jpeg";
      if (isPNG || isJPG || isJPEG) {
        this.fotos.push(URL.createObjectURL(file.raw));
        console.log(this.fotos);
      } else {
        this.$alert(
          "La imagen solo puede ser jpg o png ",
          "Formato incorrecto",
          {
            confirmButtonText: "Aceptar",
            type: "error",
            callback: () => {
              this.$refs.upload.clearFiles();
              this.fotos = "";
            },
          }
        );
      }
    },

    handleDownload(file) {
      console.log(file);
    },
    eliminar(p, i) {
      if (p.fecha) {
        this.borrando = true;
        HTTP.post("/eliminarProducto", {
          pedido: this.$route.params.pedido,
          producto: p.id,
        }).then((res) => {
          this.borrando = false;
          if (res.data) {
            this.productos.splice(i, 1);
          } else {
            this.$alert("No se pudo eliminar el producto");
          }
        });
      } else {
        this.productos.splice(i, 1);
      }
    },
    beforeUpload(file) {
      let s = {
        file: file.raw,
        maxSize: 1024,
      };
      this.resizeImage(s)
        .then((r) => {
          console.log(r);
          this.subirCamara(r);
        })
        .catch(() => {
          this.$refs.upload.submit();
        });
    },
    resizeImage(settings) {
      var file = settings.file;
      var maxSize = settings.maxSize;
      var reader = new FileReader();
      var image = new Image();
      var canvas = document.createElement("canvas");
      var dataURItoBlob = function (dataURI) {
        var bytes =
          dataURI.split(",")[0].indexOf("base64") >= 0
            ? atob(dataURI.split(",")[1])
            : unescape(dataURI.split(",")[1]);
        var mime = dataURI.split(",")[0].split(":")[1].split(";")[0];
        var max = bytes.length;
        var ia = new Uint8Array(max);
        for (var i = 0; i < max; i++) ia[i] = bytes.charCodeAt(i);
        return new Blob([ia], { type: mime });
      };
      var resize = function () {
        var width = image.width;
        var height = image.height;
        if (width > height) {
          if (width > maxSize) {
            height *= maxSize / width;
            width = maxSize;
          }
        } else {
          if (height > maxSize) {
            width *= maxSize / height;
            height = maxSize;
          }
        }
        canvas.width = width;
        canvas.height = height;
        canvas.getContext("2d").drawImage(image, 0, 0, width, height);
        var dataUrl = canvas.toDataURL("image/jpeg");
        return dataURItoBlob(dataUrl);
      };
      return new Promise(function (ok, no) {
        if (!file.type.match(/image.*/)) {
          no(new Error("Not an image"));
          return;
        }
        reader.onload = function (readerEvent) {
          image.onload = function () {
            return ok(resize());
          };
          image.src = readerEvent.target.result;
        };
        reader.readAsDataURL(file);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.botoneraGenerar{

  
  display: flex;
  max-width: 590px;
  margin: 0 auto;
  margin-top: 20px;
  flex-wrap: nowrap;
    justify-content: space-between;

}
.btntipoSolicitud {
  width: 100%;
  margin: 0;
  margin-top: 10px;
  padding: 15px;
  font-size: 16px;
  white-space: inherit;
  // text-align: left;
  line-height: 1.2;
  font-family: 'Montserrat', sans-serif;
}
.solicitudOpcion {
  padding: 10px;
  border: 1px dashed #ff9c9c;
  font-size: 13.5px;
}
// .el-radio.is-bordered+.el-radio.is-bordered {
//  margin-left: 0px;
// }

[class*=" el-icon-"],
[class^="el-icon-"] {
  // font-family: element-icons!important;
  // font-style: normal;
  // font-weight: 400;
  // font-variant: normal;
  // text-transform: none;
  // line-height: 1;
  // vertical-align: baseline;
  // display: inline-block;
  // font-size: x-large;
  // -webkit-font-smoothing: antialiased;
  font-size: 13.5px !important;
  // -moz-osx-font-smoothing: grayscale;
}
.pedido-incompleto-titulo {
  margin: 0;
  color: red;
}
.productos-devolucion-titulo {
  display: block;
  background: #fff0ee;
  color: #333;
  padding: 4px;
  margin-top: 10px;
}
.pedidos-devolucion {
  padding: 0;
  margin: 0;
  list-style: none;
}
.pedidos-devolucion > li {
  //   border-bottom: 1px solid #ddd;
  color: #000;
  border-top: 1px solid #ddd;
  padding: 8px;
  background: #fafafa;
}
.pedidos-devolucion > li:first-child {
  //   border-bottom: 1px solid #ddd;
  border-top: none;
  //   padding: 4px;
}

.pedidos-devolucion > li > strong {
  color: red;
}
.articulo_reclamo {
  display: block;
  width: 100%;
  margin: 10px auto;
  padding: auto;

  margin-left: 0px;
}
.articulo_reclamo > span.el-radio__label {
  padding-left: 5px;
}
.table-productos {
  margin-top: 40px;
}
.table-productos tbody > tr > td > img {
  width: 40px;
  text-align: center;
  float: left;
  // padding: 6px;
}
.table-productos tbody > tr > td > strong {
  text-transform: capitalize;
  float: left;
  padding-top: 10px;
  padding-left: 20px;
}
.table-productos > tbody > tr > td,
.table-productos > thead > tr > td {
  padding: 0;
  margin: 0;
}
.data-vtex {
  min-height: 300px;
  overflow: hidden;
  max-width: 600px;
  margin: 0 auto;
  border-radius: 12px;
  border:1px solid #c2c2c2;
  // padding: 10px;
  margin-top: 65px;
  font-family: 'Montserrat', sans-serif !important;

}
.titulo-motivo-h3 {
  margin: 0;
  font-weight: 700;
  color: #000;
  padding: 15px 0px;
  text-align: center;
}
.data-vtex-ul {
  list-style-type: none;
  padding: 0;
  width: 100%;
  //   border: 1px solid #f1f1f1;
  margin: 0;
  height: 300px;
  overflow-y: scroll;
}
.data-vtex-ul > li {
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 8px;
  // border: 1px solid #f1f1f1;
  cursor: pointer;
  transition: all 0.2s;
}
.data-vtex-ul > li:hover {
  background: #f1f1f1;
  // border-left: 4px solid #ff7124;
}
.data-vtex-ul > li > p {
  text-transform: capitalize;
  text-align: left;
  word-break: break-word;
  font-size: 14px;
  font-weight: 500;
  color: #475467;
      width: 72%;
    margin-left: 10px;
}
.data-vtex-ul > li > img {
  width: 40px;

  text-align: center;
  padding: 6px;
  // margin: 2px auto;
  //   float: left;
}
i.el-icon-picture-outline {
  font-size: 30px !important;
  display: block;
  margin: 0 auto;
  text-align: center;
  color: #fadedc;
}
.data-vtex-ul > li > img,
.thumbnail {
  width: 40px;

  text-align: center;
  padding: 4px;
  //   border-right:1px solid #ddd;
  margin-right: 10px;
  height: 100%;
}
.el-button {
  vertical-align: sub;
}

.el-dialog__headerbtn {
  width: 0px;
  position: absolute;
  top: 13px;
  right: 45px;
  padding: 0;
  background: 0 0;
  border: none;
  outline: 0;
  cursor: pointer;
  font-size: 16px;
}

.items-seleccion {
  margin: 0;
  padding: 15px;
  font-size: 16px;
  background: #bfbe51;
  text-align: left;
  color: white;
  text-align: left;
  font-weight: 700;
  
}
.selected,
.selected:hover {
  background: rgb(212 110 125 / 10%) !important;
  // border: 1px solid #e57373 !important;
  // border-left: 4px solid #ef9a9a !important;
}
.selected:last-child {
  //  border-bottom: 1px solid #8bc34a !important;
}
.item-unselected-icon {
  margin-left: auto;

  font-size: 16px !important;
  color:#475467;
}
.item-selected-icon {
  margin-left: auto;
  font-size: 16px !important;
  color: #f44336;
}
.items-retiro {
  margin: 0;
  padding: 20px;
  margin-top: 10px;
  background: #fafafa;
  width: 94.8%;
  // border-left: 5px solid #ddd;
  text-align: center;
  margin-bottom: 10px;
}
.item-ok {
  // border-left: 4px solid #cddc39;
}
.item-cambio {
  // border-left: 4px solid #f44336;
  background: rgb(244 67 54 / 6%);
}
.item-cambio-parcial {
  // border-left: 4px solid #f4ce36;
  background: rgb(255 235 59 / 15%);
}
.table-items > tr > th {
  padding: 3px 10px;
}
</style>
